import { sendAdsEventsTrack as sendAdsEventsTrackCore } from 'common/services/ads-events-track.service';
import { logError } from '../sentry';
import { AdContextStore } from '../stores/ad-context.store';
import { ConfigStore } from '../stores/config.store';

export function sendAdsEventsTrack(event: 'loaded' | 'loaded_error') {
  const adContext = AdContextStore.getInstance()?.adContext;
  if (!adContext) return Promise.resolve();

  return sendAdsEventsTrackCore(
    event,
    adContext,
    ConfigStore.getInstance().config
  ).catch(logError);
}
